// extracted by mini-css-extract-plugin
export default {"container":"_2fd7aa9e","header":"_58b24aa6","subheader":"_e106c7c2"};